module.exports = __webpack_public_path__ + "img/sonargroup-contact.0d664495.webp";